import React from 'react'
import OrderStore from '../../stores/order-store'
import ImageStore from '../../stores/image-store'
import UploadStore from '../../stores/upload-store'
import UpsaleGroup from './upsale-group'
import PriceFormatter from '../../utils/price-formatter'
import AdobeAnalytics from '../../utils/adobe-analytics'
import OpeProgress from '../app-templates/ope-progress-bar'
import UploadProgressBar from '../app-selector/upload-progress-bar'
import Modal from '../utils/ope-modal'
import EditorActions from '../../actions/editor-actions'
import TouchButton from '../utils/ope-touch-button'
import OpeImageLocal from '../../objects/opeimage/local'
import TouchLink from '../utils/ope-touch-link'
import createReactClass from 'create-react-class'


function orderItems() {
  return OrderStore.getItems();
}

function uploadData() {
  return UploadStore.getData();
}

function imageData() {
    return ImageStore.getData();
}

var Upsale = createReactClass({

  mounted: false,
  serverDataTimeout: null,

  getInitialState: function() {
    return {items: orderItems(), upload: uploadData(), triedToFinishWithoutCompleteUpload: false, warningsAlreadyShown: false, imageData: imageData(), waitForServerData: true};
  },

  _onChange: function() {
      this.setState({items: orderItems(), upload: uploadData(), imageData: imageData()});
  },

  _getTotalPrice: function() {
    var items = this.state.items,
        totalPrice = 0;
    for(var x = 0; x < items.length; x++) {
      var item = items[x];

      totalPrice = totalPrice + parseFloat(item.getPrice());
    }

    return Math.round(totalPrice * 100) / 100;
  },

  _getQuantity: function() {
    var items = this.state.items,
        quantity = 0;
    for(var x = 0; x < items.length; x++) {
      quantity = quantity + items[x].getQuantity();
    }

    return quantity;
  },

  componentWillMount: function() {
    //Reset all upsale options before entering this page
    for (var i = 0; i < this.state.items.length; i++) {
      this.state.items[i].resetUpsaleOptions();
    }

    OrderStore.addChangeListener(this._onChange);
    UploadStore.addChangeListener(this._onChange);
    ImageStore.addChangeListener(this._onChange);

  },

  componentDidMount: function () {
      this.mounted = true;
      var instance = this;

      if (Object.keys(OrderStore.getItems()).length === 0) {
          instance.setState({statusMessage: _('Empty session.')});
          window.location.hash = "";
      } else {
          AdobeAnalytics.setUpsellPage();

          //Scroll to top
          document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
  },

  componentWillUnmount: function() {
    this.mounted = false;
    OrderStore.removeChangeListener(this._onChange);
    UploadStore.removeChangeListener(this._onChange);
    ImageStore.removeChangeListener(this._onChange);
  },

  getDistinctProductsAndWidthList: function () {
    var itemList = this.state.items;
    var sortedItemList = {};

    for (var i = 0; i < itemList.length; i++) {
      var key = itemList[i].getProductId() + '_' + itemList[i].getProductWidth();
      if (!sortedItemList.hasOwnProperty(key)) {
        sortedItemList[key] = [];
      }
      sortedItemList[key].push(itemList[i]);
    }
    return sortedItemList;
  },

  shouldShowCropWarning: function () {
    if (this.state.warningsAlreadyShown) {
      return false;
    }
    for(var i = 0; i < this.state.items.length; i++) {
      var item = this.state.items[i];
      if(item.getAutoCropWarning()) {
        return true;
      }
    }
    return false;
  },

  shouldShowLowResWarning: function () {
    if (this.state.warningsAlreadyShown) {
      return false;
    }
    for(var i = 0; i < this.state.items.length; i++) {
      var item = this.state.items[i];
      if(item.getLowResWarning()) {
        return true;
      }
    }
    return false;
  },

  //How many images have a crop warning?
  getCropWarningCount: function () {
    var count = 0;
    for(var i = 0; i < this.state.items.length; i++) {
      var item = this.state.items[i];
      if(item.getAutoCropWarning()) {
        count++;
      }
    }
    return count;
  },

  //How many images have a low res warning?
  getLowResWarningCount: function () {
    var count = 0;
    for(var i = 0; i < this.state.items.length; i++) {
      var item = this.state.items[i];
      if(item.getLowResWarning()) {
        count++;
      }
    }
    return count;
  },
  getUpsaleGroupKeysSorted: function (groupedItemList) { //This is used to sort the groups, so that 10x10 is first, then 10x12, then 13x13 and such.
    var keys = [];

    for (var k in groupedItemList) {
      if (groupedItemList.hasOwnProperty(k)) {
        keys.push(k);
      }
    }

    keys.sort();

    return keys;
  },
  nextPageHandler: function () {
    // log statistics
    logToCentralServer("Next page, stats", {
      uploadData: this.state.upload,
      itemsCount: this.state.items.length,
      imageIds: Object.keys(this.state.imageData),
      triedToFinishWithoutCompleteUpload: this.state.triedToFinishWithoutCompleteUpload,
      warningsAlreadyShown: this.state.warningsAlreadyShown,
      waitForServerData: this.state.waitForServerData
    })
    //The next button is disabled untill all images have been uploaded.
    //If the user clicks it before everything is uploaded, then we should
    //present a message to the user telling her that all images must be uploaded
    //before adding to cart. This will set a state that can display this message.
    if (!this.allowNextStep()) {
      this.setState({triedToFinishWithoutCompleteUpload: true});
    }
  },
  allowNextStep: function () {
    if (this.state.items.length === 0) {
         return false;
    }

    if (this.state.upload.totalImagesToUpload > 0) {
        // totalImagesUploaded does not represent the final state of file's upload process.
        if (this.state.upload.totalImagesToUpload !== this.state.upload.serverData) {
            return false;
        }
    }

    // If we failed to read out the exif data client side, we need to wait for the server side data
    // in order to get the rotation (orientation) correct
    if (this._checkIfExifReadingFailed()) {
        if (this.state.upload.serverData !== this.state.upload.totalImagesUploaded) {

          //We don't want to wait forever for server data, so we set a timeout.
          //If the server data is still not here after the timeout, we risk it and
          //pass on the order. The risk is getting streched images, but the chances are very small.
          if (this.state.waitForServerData) {
            if (this.serverDataTimeout === null) {
              this.serverDataTimeout = setTimeout(function () {
                if (this.mounted) {
                  this.setState({waitForServerData: false});
                }
                this.serverDataTimeout = null;
              }.bind(this), 1000*30)
            }

            return false;
          }
        }
    }

    return true;
  },
  _checkIfExifReadingFailed: function () {
      var exifReadingFailed = false;
      var uploadWarnings = UploadStore.getData().uploadWarnings;
      if (typeof uploadWarnings === 'object') {
          for (var imageId in uploadWarnings) {
              if (!uploadWarnings.hasOwnProperty(imageId)) {
                  continue;
              }

              if (Array.isArray(uploadWarnings[imageId])) {
                  for (var i = 0; i < uploadWarnings[imageId].length; i++) {
                      var warning = uploadWarnings[imageId][i];
                      if (warning.code === 'READ_EXIF_FAILED') {
                          exifReadingFailed = true;
                          break;
                      }
                  }
              }
              if (exifReadingFailed) {
                  break;
              }
          }
      }
      return exifReadingFailed;
  },
  _disableWarnings: function(warningType) {
    if (this.mounted) {
      this.setState({warningsAlreadyShown: true});
    }
  },

  _closeModalWarning: function () {
    $('#product-list-warnings')[0].style.display = "none";
  },

  dontShowWarningsAgainWhenGoingBackToFixWarnings: function () {
    this._closeModalWarning();
    EditorActions.setCropLowresWarningSeen(true);
  },
  render: function() {
    var upsaleGroupComponentList = [];
    var sortedItemList = this.getDistinctProductsAndWidthList();
    var groupKeysSorted = this.getUpsaleGroupKeysSorted(sortedItemList); //Sort the keys so that the groups become ordered in the correct manner
    for (var i = 0; i < groupKeysSorted.length; i++) {
      var key = groupKeysSorted[i];
      upsaleGroupComponentList.push(<UpsaleGroup itemList={sortedItemList[key]} key={key} productId={key} />);
    }

    var navEnabled = this.allowNextStep();

    var warningList = [];

    if(this.shouldShowLowResWarning()) {
      warningList.push(
        <div key="warning-lowres" className="modal-warning-block">
          <header>
            <h4><div className="ope-icon ope-icon--lowres"></div><span>{_("Check your low resolution images")}</span></h4>
          </header>
          <div className="main">
            <div className="ope-modal__product-list">
              <p>{_("%s images have a low-resolution warning. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.", this.getLowResWarningCount())}</p>
            </div>
          </div>
        </div>
      )
    }

    if(this.shouldShowCropWarning()) {
      warningList.push(
        <div key="warning-crop" className="modal-warning-block">
          <header>
            <h4><div className="ope-icon ope-icon--crop"></div><span>{_("Check your cropped photos")}</span></h4>
          </header>
          <div className="main">
            <div className="ope-modal__product-list">
              <p>{_("%s photos have been cropped and not validated. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.", this.getCropWarningCount())}</p>
            </div>
          </div>
        </div>
      );
    }

    var warnings;
    if (warningList.length > 0) {
      warnings = <Modal closeCallback={this._disableWarnings} id="product-list-warnings" show={true}>
                    <div style={{padding: "10px"}}>
                     <header>
                        <h2>{_("Some photos need attention")}</h2>
                      </header>
                      <div className="main">
                        <div className={warningList.length > 1 ? 'multiple-warnings' : ''}>
                          {warningList}
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      <footer className="text-center">
                        <TouchButton className="button small tertiary" onTap={this._closeModalWarning}>
                          {_("Continue")}
                        </TouchButton>
                        <TouchLink href="/editor" className="button small" extraClickHandler={this.dontShowWarningsAgainWhenGoingBackToFixWarnings} style={{marginLeft: "20px"}}>
                          {_("Check photos")}
                        </TouchLink>
                      </footer>
                    </div>
                  </Modal>
    }

    return (
      <div className="ope-upsale">
        { warnings }

        <UploadProgressBar />
        <OpeProgress progressActiveStates={[false, false, true]} />
        <header className="ope-section__header">
          <h2>{_("Do more with your photos")}</h2>
        </header>

        <div className="ope-upsale">
          {upsaleGroupComponentList}
        </div>
        <p>
          <TouchLink href="/editor">{_("")}</TouchLink>
        </p>

        <footer className="ope-section__footer">
          <div className="ope-section__footer__seperator">
            <span className="ope-section__footer__seperator-line" />
            <span className="ope-section__footer__seperator-label">{ _("Do more with your photos") } </span>
            <span className="ope-section__footer__seperator-line" />
          </div>

          <div className="ope-section__footer__summary row">
            <div className="ope-section__footer__quantity small-9 medium-9 columns  ope-grid-column-nopadding">{
              _("You’re ordering %s photos", this._getQuantity())}
            </div>

            <div className="small-3 medium-3 columns ope-upsale__total-price  ope-grid-column-nopadding">
              { PriceFormatter( this._getTotalPrice() ) }
            </div>
          </div>

          <nav className="ope-section__footer__nav row">
            <div className="small-12 medium-6 medium-push-6 columns ope-grid-column-nopadding" style={{textAlign: 'right'}}>
                {
                  this.state.triedToFinishWithoutCompleteUpload && !this.allowNextStep() ?
                    <div className="ope-upsale__addToCartButtonWarning">{_("For you to order, we need to finish uploading your photos")}</div>
                    :
                    <div></div>
                }
                <TouchLink extraClickHandler={this.nextPageHandler} href="/finished" id="addToCartButton" className="button ope-next-button"  disabled={!navEnabled}>
                  {_("Order your prints")}
                  <i className="icon arrow-right"></i>
                </TouchLink>
              </div>

              <div className="small-12 medium-6 medium-pull-6 columns  ope-grid-column-nopadding">
                {/* <TouchLink href="/editor" className="ope-link">{_("Save and finish later")}</TouchLink> */}
              </div>

          </nav>
        </footer>
      </div>
    );
  }
});

export default Upsale;
